export default "__VITE_ASSET__7ecc07a8__"